export const ALL_COUNTRIES = [
  {
    id: '60e4482c7cb7d4bc4849c4d5',
    codeNumber: '+20',
    removeZeroWithCodeNumber: true,
    codeName: 'EG',
    name: 'Egypt'
  },
  {
    id: 'eF-3f9FZr',
    codeNumber: '+966',
    removeZeroWithCodeNumber: true,
    codeName: 'SA',
    name: 'Saudi Arabia'
  }
];

export const DEFAULT_COUNTRY = ALL_COUNTRIES[0];
